import NumberFormat from 'react-number-format';

import { Icon } from '../../UI';

import { formatDate, getLogo } from '../../../helpers/functions';

import { IAsset } from '../../../types/model';
import { ProfitLoss } from '../../ProfitLoss';
import { Asset } from '../../Asset/Asset';
import InfoTooltip from '../../InfoTooltip/Info-tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TDateISODate } from '../../../types/date';
import { RankedAsset } from './index';

export interface RankedCardProps {
  rank: number; // 1 | 2 | 3
  asset: RankedAsset;
  width?: number;
  gradient: [string, string];
}

export const RankedCard = ({
  rank,
  asset,
  width = 3,
  gradient,
}: RankedCardProps) => {
  const heights = ['164px', '130px', '111px'];
  const widths = ['117px', '255px', '188px'];

  const { t } = useTranslation();
  return (
    <div
      className={`
        bg-gradient-to-b
        from-${gradient[0]}
        to-${gradient[1]}
        rounded-xl
        m-3
      `}
      style={{ height: heights[rank - 1], width: widths[width - 1] }}
    >
      <div className="text-white mx-3">
        <span className={'text-2xl'}>{rank}</span>
        <div className="border-b border-white w-full h-px opacity-20" />
        <div className="mt-2 flex flex-col">
          <div className="flex items-center gap-1">
            <Asset
              id={asset.id}
              logo={asset.logo}
              name={asset.name}
              symbol={asset.symbol}
              type={asset.type || ''}
              showSubtitle={false}
              showBorder={false}
            />

            <InfoTooltip
              isTooltipIconVisible
              content={
                <>
                  <div>{t('widget.priceChanges.variationBetween')}</div>
                  <div>
                    {t('widget.priceChanges.variationFrom', {
                      date: formatDate(asset.startDate),
                    })}
                  </div>
                  <div>
                    {t('widget.priceChanges.variationTo', {
                      date: formatDate(asset.endDate),
                    })}
                  </div>
                </>
              }
              tooltipIconClassName={'ml-1 text-white'}
            />
          </div>

          <div className={`flex flex-col ${width !== 1 && 'ml-9 -mt-1'}`}>
            <ProfitLoss
              allowNegativePercentage
              percentage={asset.percentage}
              percentageClassName="text-base font-semibold"
              textColor="white"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export function Percentage({
  percentage,
  className = '',
}: {
  percentage: number;
  className?: string;
}) {
  const isGain = Math.sign(percentage) === 1;

  return (
    <div className={`text-md font-semibold flex items-center gap-1`}>
      <Icon svgName={isGain ? 'gain' : 'loss'} className={`mx-px w-3 h-3`} />
      <NumberFormat
        className={`bg-transparent text-md font-semibold w-full ${className}`}
        readOnly
        decimalScale={2}
        decimalSeparator=","
        suffix="%"
        value={percentage}
      />
    </div>
  );
}
